import React from 'react';
import { Modal, Typography } from 'antd';
import { ConfigProvider } from 'antd';
import { COLORS } from '../../../themes/colors';
import '../modal.scss';

const { Paragraph } = Typography;
const ClearQuestionsModal: React.FC<{
  isOpen: boolean;
  handleCancel: () => void;
  handleOk: () => void;
}> = ({ isOpen, handleOk, handleCancel }) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: COLORS.cipherGreenL0,
        },
      }}
    >
      <Modal
        closable={false}
        className="modal"
        title="Are you sure?"
        okText="Yes, I'm sure."
        onOk={handleOk}
        onCancel={handleCancel}
        cancelText="No, I'm good."
        open={isOpen}
      >
        <Paragraph>
          If you change your answer to this question, any answers that came
          after it will be removed. Do you want to continue?
        </Paragraph>
      </Modal>
    </ConfigProvider>
  );
};

export default ClearQuestionsModal;
